// extracted by mini-css-extract-plugin
export default {"text":"Label_text__r4W4u"};